import DeviceApi from "../api/service/device/DeviceApi";

export default class DeviceService {
    api;

    constructor() {
        this.api = new DeviceApi();
    }

    async getDeviceList({ shopCode }) {
        return this.api.getDeviceList({ shopCode }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getDeviceStatus({ shopCode }) {
        return this.api.getDeviceStatus({ shopCode }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getDeviceDetails({ idDevice }) {
        return this.api.getDeviceDetails({ idDevice }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getDeviceDetailsHistory({ deviceId, page = 1, pageSize = 20 }) {
        return this.api.getDeviceDetailsHistory({ deviceId, page, pageSize }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getDeviceErrorList({ storeId, startDay, endDay, deviceName, errorCode }) {
        return this.api.getDeviceErrorList({ storeId, startDay, endDay, deviceName, errorCode }).then((res) => {
            const resultCode = res.resultCode ?? res.result_code;
            if (resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async saveDeviceSettings({ deviceId, reqDto }) {
        return this.api.saveDeviceSettings({ deviceId, reqDto }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getDeviceSettings({ deviceId }) {
        return this.api.getDeviceSettings({ deviceId }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getSubDevice({ subDeviceId }) {
        return this.api.getSubDevice({ subDeviceId }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }

    async getSubDeviceByStore({ storeId, deviceId }) {
        return this.api.getSubDeviceByStore({ storeId, deviceId }).then((res) => {
            if (res.resultCode === "0000") {
                return res.result;
            } else {
                throw new Error(res.result);
            }
        });
    }
}
